<main
  class="h-full"
  [ngClass]="{ 'lg:pl-72': isAuthenticated() && showSidebar() }"
>
  <div class="px-2 py-2 lg:px-6 xl:px-8">
    <ng-content></ng-content>
  </div>
</main>

<!--sidebar-->
@if (isAuthenticated() && customerId()) {
  <p-drawer
    styleClass="w-full lg:w-72 bg-white dark:bg-surface-950 border-0 z-10"
    [closeOnEscape]="false"
    [modal]="false"
    [visible]="!!showSidebar()"
    (onHide)="toggleSidebar()"
    autoZIndex="false"
    baseZIndex="40"
  >
    <ng-template #headless>
      <bk-sidebar
        (closeCallback)="toggleSidebar()"
        (navCallback)="onNav(isLarge())"
      ></bk-sidebar>
    </ng-template>
  </p-drawer>
}
<bk-loading-overlay></bk-loading-overlay>
<bk-loading-bar></bk-loading-bar>
